import { REGISTER } from "redux-persist";





export const apiConstants = {

  Invoices: {
    UPLOAD_INVOICE: "Invoice/UploadInvoice",
    GET_INVOICE_FILES: "Invoice/GetInvoiceFilesList",
    GET_INVOICE_BY_ID: "Invoice/GetInvoiceById",
    PROCESS_FILE: "Invoice/ProcessFile",
    GET_INVOICE_LIST: "Invoice/GetInvoiceList",
    CANCEL_INVOICE: "Invoice/CancelInvoice",
    APPROVE_INVOICE: "Invoice/ApproveInvoice",
    SUBMIT_FOR_APPROVAL: "Invoice/SubmitForApproval",
    ADD_INVOICE: "Invoice/AddInvoice",
    UPDATE_INVOICE: "Invoice/UpdateInvoice",
    GET_INVOICES_TYPE: "Invoice/GetInvoiceTypes",
    AUDIT_INVOICES: "Invoice/GetInvoiceHistory",
    GET_PROCESSED_INVOICES_BY_ID: "Invoice/GetProcessedInvoiceDataById",
    GENERATE_OUTPUT_FILE: "Invoice/GenerateOutputFile",
    DELETE_INVOICE_BY_ID: "Invoice/DeleteInvoiceFileById",
    UPLOAD_REVERSE_FILE: "Invoice/UploadReverseFile",
    GET_BANK_DETAILS: "api/Customer/GetIfscDetails",
    GENERATE_MIS_REPORT: "Master/GenerateHDFCMISReport",
    GENERATE_PAYMENT_ADVICE: "PaymentAdvice/GeneratePaymentAdvice",
    GET_PAYMENT_ADVICE: "PaymentAdvice/GetPaymentAdviceList",
    UPDATE_PAYMENT_ADVICE: "PaymentAdvice/UpdatePaymentAdvice",
    GENERATE_PAYMENT_REPORT: "Vendor/GenerateBankFileText",
    GET_BENE_REQUEST_DATA: "Vendor/GetBeneRequestData",
    INITIATE_TEST: "Vendor/InitiateTest",
    HDFC_BENE_REGISTERATION: "Vendor/HDFCBeneRegistration",
    GET_APPROVAL_MATRIX: "Invoice/getApprovalMatrix"
  },
  Property: {
    PROPERTY_LIST: "Property/GetPropertyList",
    GET_USER_BY_PROPERTYID: "Property/GetUsersByPropertyId",
    UPLOAD_PROPERTY: "Property/UploadProperty",
    CANCEL_PROP: "Property/CancelProperty",
    APPROVE_PROP: "Property/ApproveProperty",
    AUDIT_PROPERTY: "Property/GetPropertyHistory",
    GET_VENDOR_BY_PROP_ID: "Invoice/GetVendorsByPropertyId",
    SET_PROPERTY_ACTIVE: "Property/SetPropertyActive",
    REGISTER_NEW_PROPERTY: "Property/AddProperty",
    ADD_OR_UPDATE_PROPERTY_VENDOR: "Property/AddUpdatePropertyVendors",
    REMOVE_PROPERTY_VENDOR: "Property/RemovePropertyVendors",
    UPDATE_PROPERTY: "Property/UpdateProperty",
    GET_PROPERTY_BY_ID: "Property/GetPropertyById",
    GET_PROPERTY_HISTORY: "Property/GetPropertyHistory"


  },
  AUTH: {
    LOGIN: "api/Account/Login",
    FORGOT_PASSWORD: "api/Account/ForgotPassword",
    RESEND_OTP: "api/OTP/GenerateCustomOTP",
    RESET_PASSWORD: "api/Account/ResetPassword",
    CHANGE_PASSWORD: "api/Account/ChangePassword",
    CHANGE_PASSWORD_FOR_NEW_USER: "api/Account/SetPasswordForNewUser",
    REGISTER_USER: "api/Account/RegisterUser",
    GET_PERMISSIONS: "api/NavigationPermission/GetNavigationItemsByRole",
    GET_PERMISSION_HEIRARCHY: "api/NavigationPermission/GetPermissionHierarchy",
    SAVE_PERMISSION_ROLE_WISE: "api/NavigationPermission/SavePermisisonsRoleWise",
    GET_ALL_ROLES: "api/NavigationPermission/GetAllRoles",
    GET_ROLES: "api/Account/GetRoles"
  },
  DASH: {
    GET_TOTAL_PAYABLE: "DashBoard/GetTotalPayable",
    GET_TOTAL_PAYOUT: "DashBoard/GetTotalPayout",
    GET_TOTAL_INVOICEOVERDUE: "DashBoard/GetTotalInvoiceOverdue",
    GET_TOTAL_PENDING_FOR_APPROVAL: "DashBoard/GetPendingforApprovalInvoiceCount",
    GET_TOTAL_AGREEMENT_EXPIRED: "DashBoard/GetAgreementExpiredIn30DaysCount",
    GET_TOTAL_PAYOUT_LAST_6_MONTH: "DashBoard/GetTotalPayoutLast6Months",
    GET_TOTAL_HIGHEST_PAID_INVOICE: "DashBoard/GetTop10HighestPaidInvoicelist",


  },

  VENDOR: {
    ADD_VENDOR: "Vendor/AddVendor",
    GET_VENDORS: "Vendor/GetVendorList",
    GET_VENDORBYID: "Vendor/GetVendorById",
    UPDATE_VENDOR: "Vendor/UpdateVendor",
    GET_VENDOR_EXCLUDE_PROPERTY_ID: "Vendor/GetVendorExcludingAssociated",
    GET_GSTIN_DETAIL: "api/v2.0/PANValidation/GetEnteredGSTINDetail",

  },
  USER: {
    GET_USERS: "User/GetNotAssociatedUserList",
    ASSIN_USER: "User/AssignPropertyUser",

    UPDATE_VENDOR: "Vendor/UpdateVendor",
    GET_VENDOR_EXCLUDE_PROPERTY_ID: "Vendor/GetVendorExcludingAssociated",
    DISASSOCIATE_USER: "User/DisassociatePropertyUser"

  },

  GET_INVOICE_BY_EMAIL: {
    VERIFY_TOKEN: "Invoice/GetEmailApprovalData"
  }
}